
import { Link } from 'react-router-dom';
import "../NavUserIcon/NavUserIcon.css"
const NavServiceDrop = () => {


  return ( 

    <div className="header__Dropdown">
      <div className="header__Dropdown--Services">
      Services
      </div>
        <ul className="header__Dropdown__UList">
          
          <li className="header__Dropdown__UList-li">
            <Link to="/StandardService">
            Standard Service
             </Link>
          </li>

          <li className="header__Dropdown__UList-li"><Link to="/AdvancedService">
            Advanced Service
            </Link>
          </li>

          <li className="header__Dropdown__UList-li"
           ><Link to="/FullService">
             Full Service
             </Link>
           </li>
          
        </ul>
      </div>

   );
}
 
export default NavServiceDrop;